@switch (itemType()) {
  @case (NAV_LIST_TYPE) {
    <ng-container *ngTemplateOutlet="navListTemplate" />
  }
  @case (NESTED_NAV_ITEM_TYPE) {
    <ng-container *ngTemplateOutlet="nestedNavItemTemplate" />
  }
  @case (NAV_ITEM_TYPE) {
    <ng-container *ngTemplateOutlet="navItemTemplate" />
  }
}

<ng-template #navItemTemplate>
  <a
    class="flex w-full items-center gap-2 rounded-lg p-2 text-interface-common-contrast focus-within:outline-border-common-brand hover:bg-interface-common-hover active:bg-interface-secondary-active active:text-interface-primary-color"
    [routerLink]="navItem()?.route"
    (click)="onNavItemSelect(navItem())"
    routerLinkActive="!bg-interface-secondary-active !text-interface-primary-color"
  >
    <svg-icon [src]="navItem()?.icon" />
    <span class="grow truncate text-left">
      {{ navItem()?.label }}
    </span>
    @if (navItem()?.state) {
      <ng-container
        [ngTemplateOutlet]="badgeTemplate"
        [ngTemplateOutletContext]="{ state: navItem()?.state }"
      />
    }
    @if (navItem()?.alert) {
      <ng-container [ngTemplateOutlet]="alertTemplate" />
    }
  </a>
</ng-template>

<ng-template #navListTemplate>
  <button
    (click)="onNavListSelect(navList())"
    class="flex w-full items-center gap-2 rounded-lg p-2 text-interface-common-contrast focus-within:outline-border-common-brand hover:bg-interface-common-hover active:bg-interface-secondary-active active:text-interface-primary-color"
  >
    @if (navList()?.icon) {
      <svg-icon [src]="navList()?.icon" />
    }
    <span class="grow truncate text-left">{{ navList()?.label }}</span>

    @if (isListExpanded(navList())) {
      <svg-icon src="assets/icons/general/chevron-down.svg" />
    } @else {
      <svg-icon src="assets/icons/general/chevron-right.svg" />
    }
  </button>
</ng-template>

<ng-template #nestedNavItemTemplate>
  <a
    class="relative flex w-full items-center gap-2 rounded-lg p-2 text-interface-common-contrast before:absolute before:inset-y-0 before:-left-3.5 before:block before:w-px before:bg-border-common-base focus-within:outline-border-common-brand hover:bg-interface-common-hover active:bg-interface-secondary-active active:text-interface-primary-color"
    [routerLink]="navItem()?.route"
    (click)="onNestedNavItemSelect(navItem())"
    routerLinkActive="!bg-interface-secondary-active !text-interface-primary-color"
  >
    @if (navItem()?.icon) {
      <svg-icon [src]="navItem()?.icon" />
    }
    <span class="grow truncate text-left">
      {{ navItem()?.label }}
    </span>
    @if (navItem()?.state) {
      <ng-container
        [ngTemplateOutlet]="badgeTemplate"
        [ngTemplateOutletContext]="{ state: navItem()?.state }"
      />
    }
  </a>
</ng-template>

<ng-template #badgeTemplate let-state="state">
  @switch (state) {
    @case ("new") {
      <ag1-badge-solid label="NEW" color="french-blue" />
    }
    @case ("beta") {
      <ag1-badge-solid label="BETA" color="slate" />
    }
    @case ("alpha") {
      <ag1-badge-solid label="ALPHA" color="slate" />
    }
  }
</ng-template>

<ng-template #alertTemplate>
  <div class="relative mr-1.5 aspect-square w-2 rounded-full bg-bright-red-500">
    <div
      class="absolute inset-0 animate-ping rounded-full bg-bright-red-500"
    ></div>
  </div>
</ng-template>
